import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import {
    TbFileTypePdf,
    TbBuildingBank,
    TbSettings,
    TbBell,
    TbListNumbers,
    TbTag,
    TbShieldCheck,
    TbUsers,
    TbTableImport,
    TbFilePlus,
    TbShieldSearch,
} from "react-icons/tb";
import type { OnboardingStepDTO } from "./StepRow";

export interface OnboardingChapterDTO {
    id: string;
    titleKey: string;
    steps: OnboardingStepDTO[];
    doneCount: number;
    totalCount: number;
}

// Chapter identity/ordering lives in the backend config (onboardingSteps.ts); icons are
// presentation-only, so they're mapped here rather than sent over the wire.
const CHAPTER_ICONS: Record<string, ReactNode> = {
    patients: <TbTableImport />,
    firstInvoice: <TbFilePlus />,
    layout: <TbFileTypePdf />,
    bank: <TbBuildingBank />,
    invoiceSettings: <TbSettings />,
    dunning: <TbBell />,
    goa: <TbListNumbers />,
    goaCheck: <TbShieldSearch />,
    tagsGroups: <TbTag />,
    consent: <TbShieldCheck />,
    team: <TbUsers />,
};

export function ChapterTabs({
    chapters,
    activeId,
    onSelect,
}: {
    chapters: OnboardingChapterDTO[];
    activeId: string;
    onSelect: (id: string) => void;
}) {
    const { t } = useTranslation();
    return (
        <div className="onboarding-modal__tabs-nav">
            {chapters.map((chapter) => {
                const complete = chapter.totalCount > 0 && chapter.doneCount === chapter.totalCount;
                return (
                    <button
                        key={chapter.id}
                        type="button"
                        className={`onboarding-modal__tabs-nav-btn${
                            activeId === chapter.id ? " onboarding-modal__tabs-nav-btn--active" : ""
                        }${complete ? " onboarding-modal__tabs-nav-btn--complete" : ""}`}
                        onClick={() => onSelect(chapter.id)}
                    >
                        {CHAPTER_ICONS[chapter.id]}
                        <span className="onboarding-modal__tabs-nav-label">{t(chapter.titleKey)}</span>
                        <span className="onboarding-modal__tabs-nav-count">
                            {chapter.doneCount}/{chapter.totalCount}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
